import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import keyMirror from 'react-utils/keyMirror';
import * as HubLVideoParams from 'FileManagerCore/constants/HubLVideoParams';
export const PAGE_SIZE = 90;
export const Panels = keyMirror({
  BROWSE: null,
  SEARCH: null,
  STOCK_IMAGES: null,
  FOLDER: null,
  FROM_URL: null,
  FILE_DETAIL: null,
  BULK_IMPORT_FROM_URL: null,
  IMAGE_GENERATION: null
});
export const CellTypes = keyMirror({
  FILE: null,
  FOLDER: null,
  THUMBNAIL: null,
  EMPTY: null
});
export const IMAGE_COLUMN_COUNT = 3;
export const DEFAULT_ROWS_TO_FETCH = 15;
export const FETCH_FILES_LIMIT = IMAGE_COLUMN_COUNT * DEFAULT_ROWS_TO_FETCH;
export const FILE_FOLDER_THUMB_SIZE = 34;
export const FILE_FOLDER_THUMB_SIZE_EXPANDED = 50; // half of THUMB width (100px) for ideal retina display

export const PICKER_FOLDER_CLASSNAME = 'folder-row';
export const PANEL_WIDTH = 590;
export const PANEL_WIDTH_EXPANDED = PANEL_WIDTH;
export const TrackingPanelLabels = {
  [Panels.BROWSE]: 'browse',
  [Panels.SEARCH]: 'search',
  [Panels.STOCK_IMAGES]: 'stock-images',
  [Panels.FOLDER]: 'browse-folders',
  [Panels.FROM_URL]: 'from-url',
  [Panels.BULK_IMPORT_FROM_URL]: 'bulk-import-from-url',
  [Panels.IMAGE_GENERATION]: 'image-generation'
};
export const PickerTypes = keyMirror({
  PANEL: null,
  SIDE_MODAL: null
});
export const DrawerTypes = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  HUBL_VIDEO: 'HUBL_VIDEO',
  DOCUMENT: 'DOCUMENT',
  FILE: 'FILE'
};
export const DrawerTypesToExtensions = ImmutableMap({
  [DrawerTypes.DOCUMENT]: ImmutableSet(['csv', 'doc', 'docx', 'dot', 'dotx', 'key', 'pdf', 'pot', 'potx', 'pps', 'ppsx', 'ppt', 'pptx', 'txt', 'wpd', 'wps', 'wri', 'xls', 'xlsb', 'xlsx', 'xlt', 'xlx', 'xml'])
});
export const UploadStatus = {
  FINISHED: 'FINISHED',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
  NOT_STARTED: 'NOT_STARTED'
};
export const SupportedHubLVideoParams = HubLVideoParams.SupportedHubLVideoParams;